import { render } from "./Emailpage.vue?vue&type=template&id=203a63be&scoped=true&ts=true"
import script from "./Emailpage.vue?vue&type=script&lang=ts"
export * from "./Emailpage.vue?vue&type=script&lang=ts"

import "./Emailpage.vue?vue&type=style&index=0&id=203a63be&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203a63be"]])

export default __exports__